
import * as yup from 'yup'
import { Insurer } from '../enums'

export const IndividualDiscountsSchema = yup.array().of(
    yup.object().shape({
        contractNumber: yup.string()
            .when("insurer", {
                is: (i: number) => i === Insurer.Uniqa,
                then: () => yup.string().test(
                    "should-not-contain-whitespace",
                    "Číslo smlouvy nesmí obsahovat mezery.",
                    (value: string | undefined) => !value || !value.match(/\s/)
                ),
                otherwise: () => yup.string()
            })
    })
)